import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CheckBoxGroup from '../../shared/components/CheckBoxGroup';
import {
  STIMULUS_PICTURES_TYPES,
} from '../../../../../../../types';

const picturesTypes = _.values(STIMULUS_PICTURES_TYPES);

const SyllablesConfig = ({ config, updateConfig }) => (
  <CheckBoxGroup
    config={config}
    onChange={updateConfig}
    groupName="picturesType"
    groupValues={picturesTypes}
  />
);

SyllablesConfig.propTypes = {
  config: PropTypes.object,
  updateConfig: PropTypes.func,
};

export default SyllablesConfig;
